import type { YMap } from "@yandex/ymaps3-types";

import type { FlotiqStore } from "@jti/fe-common";

import type {
  StoreFilteringByAttributes,
  StoreFiltersCategoriesEnabledParams,
  StoreLocatorCartItemProp,
  StoreLocatorFilter,
  StoreLocatorPosition,
  StoreLocatorSelectedFilter,
  StoreLocatorTranslationsFilter,
  StoreLocatorWithinCategoryFilterOperator,
} from "../../types/common";

export type UseFlotiqStoresArgs = {
  filtersTranslations?: StoreLocatorTranslationsFilter[];
  storesLimit?: number;
  cartItems?: StoreLocatorCartItemProp[];
  filterByCartAvailabilityEnabled?: boolean;
  activeStore?: FlotiqStore;
  activeStoreId?: string;
  flotiqApiKey?: string;
  flotiqContentType?: string;
  enabledFiltersCategories?: StoreFiltersCategoriesEnabledParams;
  withinCategoryFilterOperator?: StoreLocatorWithinCategoryFilterOperator;
  isFiltersSharingEnabled?: boolean;
  categoryAttributeFilter?: StoreFilteringByAttributes;
  isAsianAddressFormatEnabled?: boolean;
};

export type Map = google.maps.Map | naver.maps.Map | YMap;

export type GetFlotiqStores = (map?: Map | null) => void | Promise<void>;

export type MapPosition = {
  lat?: number;
  lng?: number;
  radius?: number;
  zoom?: number;
};

export type GetFlotiqStoresReturnType = {
  flotiqStores: FlotiqStore[];
  isNoMatchingFlotiqStores: boolean;
  activeStoreId?: string;
  filters: StoreLocatorFilter;
  newFilters: StoreLocatorFilter;
  newFiltersNumber: number;
  searchAdditionalTitle?: string;
  selectedFilters: Record<string, StoreLocatorSelectedFilter>;
  isFiltersOpened: boolean;
  isFiltersAvailable: boolean;
  selectedFiltersNumber: number;
  userMarkerPosition?: StoreLocatorPosition;
  getFlotiqStores: GetFlotiqStores;
  handleSelectStore: (storeId: string) => void;
  getUserMarkerPosition: () => void;
  handleToggleFilters: () => void;
  handleResetFilters: () => void;
  handleChangeFilters: (filters?: Record<string, StoreLocatorSelectedFilter>) => void;
  isNoStoresFilters: { value: boolean; type: string } | null;
};

export type UseFlotiqStores = (params?: UseFlotiqStoresArgs) => GetFlotiqStoresReturnType;
